// import * as memoizee_ from 'memoizee';
// const memoizee = memoizee_;
import memoizee from 'memoizee';

export function Memoize() {
  return function (target: any, key: string, descriptor: PropertyDescriptor) {
    const oldFunction = descriptor.value;
    const newFunction = memoizee(oldFunction);
    descriptor.value = function () {
      return newFunction.apply(this, arguments);
    };
  };
}
